import { Component, Input } from '@angular/core';

@Component({
    selector: 'cl-true-false-table-icon',
    template: `
        @if (value) {
          <i nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a"></i>
        }
        @if (!value) {
          <i nz-icon nzType="close-circle" nzTheme="twotone" nzTwotoneColor="#c41a1a"></i>
        }
        `,
    standalone: false
})
export class TrueFalseTableIconComponent {
    @Input()
    value: boolean = false;
}
